export enum PropertyType {
    FLAT = 'flats',
    HOUSE = 'houses',
    PLOT = 'plots',
    OTHER = 'other',
}
